const encodeSegment = (value: object) => {
  const bytes = new TextEncoder().encode(JSON.stringify(value));
  let binary = "";
  for (let i = 0; i < bytes.length; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return btoa(binary).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
};

const demoPayload = {
  UserId: "00000000-0000-0000-0000-000000000001",
  Role: "0",
  IsTemporaryPasswordChanged: "True",
  FirstName: "Demo",
  LastName: "Użytkownik",
  Email: "demo@academiq.pl",
  exp: 9999999999,
};

export const DEMO_TOKEN = [
  encodeSegment({ alg: "none", typ: "JWT" }),
  encodeSegment(demoPayload),
  "demo",
].join(".");

const formatDemoDate = (date: Date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export const setupDemoAuth = () => {
  const today = new Date();
  const from = new Date(today);
  from.setDate(today.getDate() - 3);
  const to = new Date(today);
  to.setDate(today.getDate() + 3);

  localStorage.setItem("token", DEMO_TOKEN);
  localStorage.setItem("lastCalendarViewDate", today.toISOString());
  localStorage.setItem("lastCalendarViewType", "month");
  localStorage.setItem("isEventView", JSON.stringify(true));
  localStorage.setItem("benchmarkDateFrom", JSON.stringify(formatDemoDate(from)));
  localStorage.setItem("benchmarkDateTo", JSON.stringify(formatDemoDate(to)));
};
